import React, {FC, useEffect, useMemo, useState} from "react";
import {Link, useParams} from "react-router-dom";
import {addressService} from "../../../store/actions";
import {formatNumberWithCommas, getFiat, serializeQuery, toXDCNumberWithoutFormat,} from "../../../common/utils/function";
import BTable from "../../../components/b-table";
import {useTranslation} from "react-i18next";
import TokenImage from "../token-image";

interface XRC720HoldingListProps {
    count: number;
}

interface TransactionListData {
    token: any;
    name: string;
    quantity: string;
}

const XRC720HoldingList: FC<XRC720HoldingListProps> = (props) => {
    const {address, token, tokenType} = useParams();
    const {t, i18n} = useTranslation();

    const [transactionList, setTransactionList] = useState<TransactionListData[]>([]);
    const [loading, setLoading] = useState(true);
    const [pageParams, setPageParams] = useState<any>([null]);
    const [pageIndex, setPageIndex] = useState<any>(0);
    const getBlocks = async () => {
        try {
            setLoading(true);
            addressService.getAddressTokens(address || token, serializeQuery({type: "ERC-20", ...pageParams[pageIndex]})).then((response) => {
                setTransactionList(response?.items);
                setPageParams((prevState: any) => {
                    prevState[pageIndex + 1] = response?.next_page_params;
                    return prevState;
                });
                setLoading(false);
            }).catch((e) => setLoading(false) );
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        getBlocks();
    }, [pageIndex, address]);
    const itemsListCount = transactionList.length;
    const header = useMemo(() => {
        return [
            {
                title: `${t("Token")}`,
                param: "name",
                render: (data: any) => <Link to={`/token/${data?.token?.address}`}>
                    <TokenImage image={data?.token?.icon_url} symbol={data?.token?.symbol} params={{width: 20, className: "me-1"}}/>
                    {data?.token?.name} ({data?.token?.symbol})
                </Link>
            },
            {
                title: 'Balance',
                param: 'balance',
                tooltip: true,
                render: (data: any) => <React.Fragment>
                    {getFiat(toXDCNumberWithoutFormat(data?.value, data?.token?.decimals) * Number(data?.token?.exchange_rate ?? 0), 18, "USD", true)}
                </React.Fragment>
            },
            {
                title: `${t("Quantity")}`,
                param: "quantity",
                tooltip: true,
                render: (data: any) => (
                    <React.Fragment>
                        {formatNumberWithCommas((toXDCNumberWithoutFormat(data?.value, data?.token?.decimals) *
                            Number(data?.fiat_value ?? 1)).toString())} {data?.token?.symbol}
                    </React.Fragment>
                ),
            },
        ];
    }, []);
    return (
        <BTable
            title={`Total ${itemsListCount} tokens found `}
            header={header}
            list={transactionList}
            loading={loading}
            pageIndex={pageIndex}
            setPageIndex={setPageIndex}
        />
    );
};

export default XRC720HoldingList;
